import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  font-size: ${themeGet('fontSizes.2')}px;

  p {
    margin: 0 0 ${themeGet('space.6')}px;
  }

  a {
    text-decoration: none;
    color: ${themeGet('colors.primary.main')};
    font-weight: ${themeGet('fontWeights.1')};

    &:hover {
      color: ${themeGet('colors.primary.dark')};
    }
  }
`
